export enum UserStatus {
  CREATED = 0,
  VERIFIED = 1,
  ACTIVE = 2,
  UNVERIFIED = 3,
  ACCOUNT_CLOSED = 100,
  SELF_EXCLUDED = 101,
  TIMEOUT = 102,
  OPTOUT = 103,
  DUPLICATE_ACCOUNT = 104,
}

export enum OddsType {
  DECIMAL = 1,
  FRACTIONAL = 2,
  AMERICAN = 3,
}

export enum OddsTypeName {
  DECIMAL = 'decimal',
  FRACTIONAL = 'fractional',
  AMERICAN = 'american',
}

export enum MarketingPreferencesNames {
  PHONE = 'phone',
  SMS = 'sms',
  EMAIL = 'email',
  PUSH = 'push',
}

export enum ProofRequestDocumentStatus {
  WAITING_FOR_APPROVAL = 1,
  APPROVED = 2,
  REJECTED = 3,
}

export enum ProofRequestStatus {
  PENDING = 1,
  WAITING_FOR_APPROVAL = 2,
  NEEDS_FURTHER_WORK = 3,
  APPROVED = 4,
}

export enum ProofRequestTypeLabel {
  PROOF_OF_ID = 'Proof of ID',
  PROOF_OF_ADDRESS = 'Proof of Address',
  SOURCE_OF_FUNDS = 'Source of Funds',
  SOURCE_OF_WEALTH = 'Source of Wealth',
  FACE_NEXT_TO_ID = 'Face next to ID',
  PROOF_OF_PAYMENT_METHOD = 'Proof of Payment Method',
}

export enum DocumentUploadTypeLabel {
  ID = 'ID',
  PASSPORT = 'Passport',
  DRIVING_LICENCE = 'Driving Licence',
  OTHER = 'Other',
  CITIZEN_CARD = 'Citizen card',
  RESIDENCE_PERMIT = 'Residence Permit',
  UTILITY_BILL = 'Utility bill',
  BANK_STATEMENT = 'Bank statement',
  BANK_LETTER = 'Bank letter',
  OTHER_PROOF_OF_ADDRESS = 'Other proof of address',
  PAYSLIP = 'Payslip',
  GAMBLING_WINNINGS = 'Gambling Winnings',
  INVESTMENT = 'Investment',
  PROPERTY_SALE = 'Property Sale',
  INHERITANCE = 'Inheritance',
  COMPANY_SALE = 'Company Sale',
  COMPENSATION_PAYMENT = 'Compensation Payment',
  RECENT_PAYSLIP = 'Recent Payslip',
  P60 = 'P60',
}

export enum DocumentRejectReasonLabel {
  CROPPED_DOCUMENT = 'Cropped document.',
  EXPIRED_PROOF_OF_ID = 'Expired proof of ID.',
  PROOF_OF_ADDRESS_LAST_THREE_MONTHS = 'Proof of address must be issued within the last 3 months.',
  CARD_NUMBERS_NOT_MASKED = 'Middle numbers not masked for the debit card.',
  CVV_NOT_MASKED = 'CVV not masked.',
  BOTH_PAGES_PASSPORT = 'Top and bottom pages of the passport need to be visible.',
  PROOF_ID_MUST_BE_SIGNED = 'Proof of ID must be signed.',
  DOCS_IN_PDF = 'Online documents must be sent in PDF format.',
  TOP_AND_BOTTOM_MUST_BE_VISIBLE = 'Top and bottom pages of the passport need to be visible.',
  BLURRY_IMAGE = 'Blurry image.',
  INVALID_DOCUMENT = 'Birth certificate is not valid as Proof of ID / Document not valid as Proof of ID.',
  SCANNED_NOT_ACCEPTED = 'Scanned proof of IDS documents are not acceptable.',
  SCREENSHOTS_NOT_ACCEPTED = 'Screenshots of proof of IDS documents are not acceptable.',
  RETAKE_WITHOUT_FLASH = 'Kindly re-take the picture with the flashlight switch off as all pieces of information need to be clearly visible on the document.',
  ALL_CORNERS_MUST_BE_VISIBLE = 'All 4 corners of the document needs to be visible for us to verify them.',
  MUST_HAVE_EXPIRATION_DATE = 'Proof of ID document must contain the expiration date.',
  FRONT_AND_BACK_PICTURE = 'Provide a picture of the front and the back of your ID Card/Residence Card.',
  CONTACT_KWIFF_EMAIL = 'We kindly ask you to contact us via email on help@kwiff.com providing us with a reason for the address mismatch between your Kwiff account and the proof of address provided.',
  CONTACT_BETKWIFF_EMAIL = 'We kindly ask you to contact us via email on help@betkwiff.com providing us with a reason for the address mismatch between your Betkwiff account and the proof of address provided.',
  DOCUMENT_NOT_VALID = 'Document not valid as Proof of Address.',
  DRIVER_LICENCE_NOT_VALID = "Driver's license is not valid as proof of address document.",
  SCREENSHOTS_NOT_ACCEPTABLE = 'Screenshots of proof of address documents are not acceptable.',
  PDF_SCREENSHOTS_NOT_ACCEPTABLE = 'Screenshots saved in PDF format are not acceptable.',
  ALL_CORNERS_A4 = 'The document must show all four corners in A4 size.',
  DOCUMENT_REJECTED_BY_SYSTEM = 'Document rejected by the system. Require the original PDF download via the web browser.',
  ADDRESS_MUST_CONTAINER_RESIDENTIAL_ADDRESS = 'Proof of Address document must contain the residential address.',
  FULL_NAME_AND_SURNAME = 'Proof of Address document must show at least the initial letter of your first name and full surname.',
  COVER_ACCOUNT_NUMBER = 'For your protection, kindly cover the account number showing on the document.',
  COVER_CARD_NUMBER = 'For your protection, kindly cover the MasterCard number showing on the document.',
}

export enum UserQuestionsTypes {
  CDD = 1,
  RESPONSIBLE_GAMBLING_SET_1 = 2,
  RESPONSIBLE_GAMBLING_SET_2 = 3,
}
